import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { legalContentAPI } from '../services/api';
import './LegalPage.css';

export default function PrivacyPolicyPage() {
  const [content, setContent] = useState('');
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const load = async () => {
      try {
        const response = await legalContentAPI.getPublicContent();
        setContent(response.data.privacyPolicyContent || '');
      } catch (error) {
        setContent('');
      } finally {
        setLoading(false);
      }
    };

    load();
  }, []);

  return (
    <div className="legal-page">
      <div className="legal-container">
        <header className="legal-header">
          <h1>Privacy Policy</h1>
          <div className="legal-meta">Last updated: {new Date().toLocaleDateString()}</div>
        </header>

        {loading ? (
          <p className="legal-empty">Loading...</p>
        ) : content ? (
          <div className="legal-content">{content}</div>
        ) : (
          <p className="legal-empty">Privacy Policy content has not been added yet. Use the Admin Dashboard to publish it.</p>
        )}

        <div className="legal-nav">
          <Link to="/">Back to Booking App</Link>
        </div>
      </div>
    </div>
  );
}
